export default {
  text_one: 'Optjen {{count}} point',
  text_other: 'Optjen {{count}} point',
};
